import * as React from "react";

import ContactPage from "../components/contact/contact";
import Layout from "../components/layout/layout";
import Seo from "../components/seo";
import { useTranslation } from 'react-i18next';

const Contact = () => {
  const {t} = useTranslation();
  return (
    <>
      <Seo
        title={t('contact_us')}
        description="Des questions à poser ou des commentaires à partager?"
      />
      <Layout>
        <ContactPage />
      </Layout>
    </>
  )
}

export default Contact
